module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "m-table StudentForm"
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("family_id")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "10"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.family_id),
      expression: "student.family_id"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "Family ID",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.student.family_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "family_id", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("名前")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.f_name),
      expression: "student.f_name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "姓"
    },
    domProps: {
      "value": (_vm.student.f_name)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "f_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.l_name),
      expression: "student.l_name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "名"
    },
    domProps: {
      "value": (_vm.student.l_name)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "l_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "req",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("かな")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.f_name_kana),
      expression: "student.f_name_kana"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "せい"
    },
    domProps: {
      "value": (_vm.student.f_name_kana)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "f_name_kana", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.l_name_kana),
      expression: "student.l_name_kana"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "めい"
    },
    domProps: {
      "value": (_vm.student.l_name_kana)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "l_name_kana", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "req",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("性別")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.gender,
      "label": "name",
      "searchable": false,
      "show-labels": false,
      "placeholder": "性別"
    },
    model: {
      value: (_vm.watch.gender),
      callback: function($$v) {
        _vm.$set(_vm.watch, "gender", $$v)
      },
      expression: "watch.gender"
    }
  })], 1), _vm._v(" "), _c('th', {
    staticClass: "req",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("生年月日")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.birthday),
      expression: "student.birthday"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "生年月日"
    },
    domProps: {
      "value": (_vm.student.birthday)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "birthday", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("年齢")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('div', {
    staticClass: "calc"
  }, [_vm._v(_vm._s(_vm.calcAge))])]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("公/国/私")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.school_type,
      "label": "name",
      "searchable": false,
      "show-labels": false,
      "placeholder": "公/国/私"
    },
    model: {
      value: (_vm.watch.school_type),
      callback: function($$v) {
        _vm.$set(_vm.watch, "school_type", $$v)
      },
      expression: "watch.school_type"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("学年")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "calc"
  }, [_vm._v(_vm._s(_vm.calcGrade))])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.grade_flag),
      expression: "student.grade_flag"
    }],
    attrs: {
      "type": "number",
      "placeholder": "留年・浪人"
    },
    domProps: {
      "value": (_vm.student.grade_flag)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "grade_flag", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("学校名")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.school_name),
      expression: "student.school_name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "学校名"
    },
    domProps: {
      "value": (_vm.student.school_name)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "school_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("次回引継時期")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.takeover_time),
      expression: "student.takeover_time"
    }],
    attrs: {
      "type": "text",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "次回引継時期"
    },
    domProps: {
      "value": (_vm.student.takeover_time)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "takeover_time", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("指導詳細")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.guidance_detail),
      expression: "student.guidance_detail"
    }],
    attrs: {
      "type": "text",
      "placeholder": "指導詳細"
    },
    domProps: {
      "value": (_vm.student.guidance_detail)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "guidance_detail", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("優先度")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.priority,
      "label": "name",
      "searchable": false,
      "show-labels": false,
      "placeholder": "優先度"
    },
    model: {
      value: (_vm.watch.priority),
      callback: function($$v) {
        _vm.$set(_vm.watch, "priority", $$v)
      },
      expression: "watch.priority"
    }
  })], 1), _vm._v(" "), _c('th', {
    staticClass: "req",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("役務期間")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.service_period_start),
      expression: "student.service_period_start"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "役務開始"
    },
    domProps: {
      "value": (_vm.student.service_period_start)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "service_period_start", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.service_period_end),
      expression: "student.service_period_end"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "役務終了"
    },
    domProps: {
      "value": (_vm.student.service_period_end)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "service_period_end", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("備考")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "10"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.note),
      expression: "student.note"
    }],
    attrs: {
      "placeholder": "備考"
    },
    domProps: {
      "value": (_vm.student.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "note", $event.target.value)
      }
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4f27556"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/Form/StudentForm.vue
// module id = 1466
// module chunks = 0